import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { editFunctionRequest } from '../requests/editFunctionRequest';
import { Alert } from '../../../components/Alert';
import { queryClient } from '../../../app/App';
import { AxiosError } from 'axios';

export function useEditFunction() {
	const navigate = useNavigate();

	const editFunction = useMutation({
		mutationFn: async (data: any) => {
			return editFunctionRequest(data);
		},
		onSuccess: () => {
			Alert({ message: 'Successfully edited!', type: 'success' });
			queryClient.invalidateQueries(['RESPONSIBILITY_LIST']);
			navigate(-1);
		},
		onError: (error: AxiosError) => {
			Alert({ message: error.message, type: 'error' });
		},
	});

	return { editFunction };
}
